<template>
  <div class="button-items-container">
    <template v-if="iconPosition === 'left' || !iconPosition">
      <slot name="icon"></slot>
    </template>
    <span v-if="text?.length">{{ text }}</span>
    <template v-if="iconPosition === 'right'">
      <slot name="icon"></slot>
    </template>
    <div class="button-loading-icon-wrapper" v-if="isLoading">
      <LoadingIcon color="white" />
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingIcon from '@/features/ui/components/icons/loading-icon.vue'

defineProps<{
  text?: string
  iconPosition?: 'left' | 'right'
  isLoading?: boolean
}>()
</script>
